module.exports = __webpack_public_path__ + "static/media/2A604637-837D-49B7-892E-73D39E112BE1.e0d16a0e.JPG";